import { render, staticRenderFns } from "./ModalItemInfo.vue?vue&type=template&id=f517165a"
import script from "./ModalItemInfo.vue?vue&type=script&lang=js"
export * from "./ModalItemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports